import React from 'react';
import { BoldBodyText, FlexRow, Grid, SeeMoreLessBlock, SeeMoreLessSize, UserIcon } from 'ui-toolkit';
import { IVendorCommentData } from '../../../types/order/comment/IVendorComment';
import { eAuthorType } from '../../../types/order/comment/eAuthorTypes';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

export const CommentContent: React.FC<{ comment: IVendorCommentData }> = ({ comment }) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const authorArray = comment.author.fullName.split(' ');

  const displayName =
    isZillowClosingEnabled && comment.author.type === eAuthorType.Admin ? 'Zillow Closing' : comment.author.fullName;

  return (
    <Grid templateColumns={'min-content 1fr'}>
      <UserIcon
        firstName={authorArray[0] || ''}
        lastName={authorArray[authorArray.length - 1] || ''}
        showLogoIcon={comment.author.type === eAuthorType.Admin}
      />
      <Grid>
        <FlexRow justifyContent={'space-between'}>
          <BoldBodyText>{displayName}</BoldBodyText>
          <BoldBodyText>
            {getDateString(DateFormat.longDateTime, comment.updatedAt || comment.createdAt, true)}
          </BoldBodyText>
        </FlexRow>
        <SeeMoreLessBlock maxHeight={SeeMoreLessSize.small}>{comment.content}</SeeMoreLessBlock>
      </Grid>
    </Grid>
  );
};
